module.exports = __webpack_public_path__ + "static/media/Envelope.c3c5e234.png";